const user = {
    state: {
        isLogin: false,
        token: '',
        userInfo: null, //用户信息
        version: null,
        nickName: '', // 昵称
        avatar: '',// 头像
        equipment:''  //设备信息
    },
    mutations: {
        SET_VERSION: (state, version) => {
            state.version = version;
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_LOGIN_SUCCESS: (state, token) => {
            state.isLogin = true;
            state.token = token;
            console.log('DEBUG_LOG:user.js/login success', token);
            sessionStorage.removeItem('performanceTimes');
        },
        SET_LOGOUT: state => {
            state.isLogin = false;
            state.token = '';
            state.userInfo = null;
            state.name = null;
            state.nickName = '';
            state.avatar = '';
            sessionStorage.removeItem('performanceTimes');
        },
        SET_USER: (state, userinfo) => {
            console.log('DEBUG_LOG:set user', userinfo);
            state.userInfo = userinfo;
            sessionStorage.removeItem('performanceTimes');
        },
        SET_NICKNAME: (state, nickName) => {
            state.nickName = nickName;
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar;
        },
        SET_DEVICE_INFO: (state,data) => {
            state.equipment = data;
        }
    },
    actions: {
    },
    getters: {
        version: state => state.version,
        token: state => state.token,
        userInfo: state => state.userInfo,
        isLogin: state => state.isLogin,
        nickName: state => state.nickName,
        avatar: state => state.avatar,
        equipment: state => state.equipment
    }
};

export default user;